import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MenuUnfoldOutlined, PlusCircleOutlined } from "@ant-design/icons";
import {
  Layout,
  Menu,
  Input,
  Button,
  message,
  Dropdown,
  Modal,
  Tooltip,
} from "antd";
import {
  EllipsisOutlined,
  EditOutlined,
  DeleteOutlined,
  ArrowUpOutlined,
  ReadOutlined,
  CloseCircleOutlined,
  PlusCircleFilled,
  DownCircleTwoTone,
  SmileOutlined,
  CompassOutlined,
  SlidersOutlined,
  DotChartOutlined,
  SoundOutlined,
  PieChartOutlined,
  PieChartFilled,
} from "@ant-design/icons";
import "wired-elements";
import Blog from "./Footer";
import DiscoverPage from "./DiscoverPage";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartBar,
  faBlog,
  faInfoCircle,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import Sectors from "./Sectors";
const { Header, Content, Sider } = Layout;
const stockbuzzLogo = "/Stockbuzz.png";

export const handleChatRename = async (
  user_value_cookie,
  activeThread,
  newName,
  setLoading,
  setActiveThread,
  message
) => {
  console.log(newName);
  setLoading(true);
  try {
    const apiUrl =
      "https://hb07tmq1xc.execute-api.us-east-1.amazonaws.com/test1";
    const requestData = {
      operation: "renameChat",
      username: user_value_cookie,
      chat_id: activeThread.id,
      chat_name: newName,
    };

    await axios.post(apiUrl, requestData);

    setActiveThread({ ...activeThread, name: newName });
    message.success("Chat renamed successfully");
  } catch (error) {
    message.error("Failed to rename chat");
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};

export const handleDeleteClick = async (
  user_value_cookie,
  thread,
  threads,
  setLoading,
  setActiveThread,
  message
) => {
  setLoading(true);
  try {
    const apiUrl =
      "https://hb07tmq1xc.execute-api.us-east-1.amazonaws.com/test1";
    const requestData = {
      operation: "deleteChat",
      username: user_value_cookie,
      chat_id: thread.id,
    };

    await axios.post(apiUrl, requestData);

    // Find the index of the deleted thread
    const deletedThreadIndex = threads.findIndex((t) => t.id === thread.id);

    // Remove the deleted thread from the threads array
    const updatedThreads = [...threads];
    updatedThreads.splice(deletedThreadIndex, 1);

    // Set the first thread as the active thread if the active thread is the deleted one
    setActiveThread((prevActiveThread) =>
      prevActiveThread?.id === thread.id
        ? updatedThreads.length > 0
          ? updatedThreads[0]
          : null
        : prevActiveThread
    );

    message.success("Chat deleted successfully");
  } catch (error) {
    message.error("Failed to delete chat");
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};

export const MenuComponent = ({
  handleMenuClick,
  handleInputChange,
  user_value_cookie,
  thread,
  newChatName,
  setLoading,
  setActiveThread,
  threads,
}) => {
  return (
    <Menu>
      <Menu.Item
        key="rename"
        icon={<EditOutlined />}
        style={{ fontSize: "small", display: "flex", alignItems: "center" }}
        onClick={handleMenuClick}
      >
        {" "}
        <span style={{ marginRight: "8px" }}>Rename</span>
        <Input
          defaultValue=""
          onChange={handleInputChange}
          onPressEnter={() =>
            handleChatRename(
              user_value_cookie,
              thread,
              newChatName,
              setLoading,
              setActiveThread,
              message
            )
          }
          onBlur={() =>
            handleChatRename(
              user_value_cookie,
              thread,
              newChatName,
              setLoading,
              setActiveThread,
              message
            )
          }
          autoFocus
          onClick={(e) => e.stopPropagation()}
          style={{ width: "auto", flex: 1 }}
        />
      </Menu.Item>
      <Menu.Item
        key="delete"
        icon={<DeleteOutlined />}
        style={{ fontSize: "small" }}
        onClick={() =>
          handleDeleteClick(
            user_value_cookie,
            thread,
            threads,
            setLoading,
            setActiveThread,
            message
          )
        }
      >
        Delete
      </Menu.Item>
    </Menu>
  );
};

export const SideBarComponent = ({
  isMobile,
  siderVisible,
  setSiderVisible,
  navigate,
  activeButton,
  setActiveButton, // Setter for activeButton from parent
  handleNewChatClick, // Original handler for new chat
  handleThreadClick,
  handleMenuClick,
  handleInputChange,
  user_value_cookie,
  activeThread,
  newChatName,
  setLoading,
  setActiveThread,
  threads,
  currentUser,
}) => {
  // Local state for navigation buttons (e.g. Discover, Screens, etc.)
  const [activeNavButton, setActiveNavButton] = useState(null);

  // When a nav button is clicked, we activate it and deactivate the new-chat button.
  const handleNavClick = (buttonName, path) => {
    setActiveNavButton(buttonName);
    setActiveButton(null); // Deactivate new-chat button
    navigate(path);
    if (isMobile) {
      setSiderVisible(false);
    }
  };

  // Local wrapper for new chat button click that clears any nav button.
  const handleNewChatLocal = () => {
    setActiveNavButton(null); // Clear any nav button active state
    setActiveButton("newChat");
    handleNewChatClick();
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSiderVisible(false);
    }
  };

  const handleBlogClick = () => {
    window.location.href = "https://www.stockbuzz.ai/blogs";
  };

  const handleAboutUsClick = () => {
    window.location.href = "https://www.stockbuzz.ai/AboutUs";
  };

  const handleMetricsClick = () => {
    window.location.href = "https://www.stockbuzz.ai/Metrics";
  };

  const handleContactClick = () => {
    window.location.href = "https://www.stockbuzz.ai/Contact";
  };

  const navigateTo = (path) => {
    navigate(path);
    closeSidebar();
  };
  // inside SideBarComponent, before the return:
  const handleSectorClick = () => {
    setActiveNavButton(null); // clear other nav highlights
    setActiveButton("Sectors"); // highlight the sector button
    navigate("/Sectors"); // go to your sector route
    if (isMobile) setSiderVisible(false);
  };

  // Common style function for sidebar buttons; inactive buttons have border "none"
  const SideBarButtonStyle = (isActive) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "90%",
    backgroundColor: isActive ? "#f0f0f0" : "transparent",
    border: isActive ? "1px solid #595959" : "none",
    color: isActive ? "#595959" : "black",
    fontWeight: isActive ? "bold" : "normal",
    margin: "0 auto 1rem",
    borderRadius: ".1rem",
  });

  return (
    <Sider
      width={isMobile ? "70%" : "20%"}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        background: "#f5f5f5",
        borderRight: "1px solid #f0f0f0",
        left: 0,
        zIndex: 1000,
        display: siderVisible ? "block" : "none",
      }}
    >
      {isMobile && (
        <Button
          icon={
            <CloseCircleOutlined style={{ fontSize: "large", color: "grey" }} />
          }
          style={{
            position: "absolute",
            backgroundColor: "transparent",
            border: "none",
            top: 0,
            right: 0,
            zIndex: 5000,
          }}
          onClick={closeSidebar}
        />
      )}
      {!isMobile && (
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: "5%" }}
        >
          <wired-button
            elevation="2"
            style={{
              width: "80%",
              margin: "2%",
              marginLeft: "15%",
              fontWeight: "normal",
            }}
            onClick={() => navigate("/discover")}
          >
            Stockbuzz.ai
          </wired-button>
        </div>
      )}
      {!isMobile && (
        <div style={{ fontSize: "small", marginLeft: "15%" }}>
          Search engine for stocks
        </div>
      )}
      {!isMobile && (
        <Button
          style={{
            width: "70%",
            marginTop: "15%",
            marginBottom: "10%",
            backgroundColor: "transparent",
            border: "none",
            marginLeft: "-10%",
            color: activeButton === "newChat" ? "#595959" : "black",
            fontWeight: activeButton === "newChat" ? "bold" : "normal",
          }}
          onClick={handleNewChatLocal}
        >
          {activeButton === "newChat" ? (
            <PlusCircleFilled />
          ) : (
            <PlusCircleOutlined />
          )}
          New Chat
        </Button>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: isMobile ? "20%" : "0%",
        }}
      >
        <Button
          style={SideBarButtonStyle(activeNavButton === "companyAnalysis")}
          onClick={() => handleNavClick("companyAnalysis", "/company-analysis")}
        >
          <DotChartOutlined style={{ marginRight: "8px" }} /> Company Analysis
        </Button>
        <Button
          style={SideBarButtonStyle(activeNavButton === "Sectors")}
          onClick={handleSectorClick}
        >
          {activeButton === "sectors" ? (
            <PieChartFilled style={{ marginRight: "8px" }} />
          ) : (
            <PieChartOutlined style={{ marginRight: "8px" }} />
          )}
          Sectors
        </Button>
        <Button
          style={SideBarButtonStyle(activeNavButton === "screens")}
          onClick={() => handleNavClick("screens", "/screens")}
        >
          <SlidersOutlined style={{ marginRight: "8px" }} /> Stock Screener
        </Button>
        <Button
          style={SideBarButtonStyle(activeNavButton === "quarterlyEarnings")}
          onClick={() =>
            handleNavClick("quarterlyEarnings", "/quarterly-earnings")
          }
        >
          <SoundOutlined style={{ marginRight: "8px" }} /> Quarterly Earnings
        </Button>
        <Button
          style={SideBarButtonStyle(activeNavButton === "discover")}
          onClick={() => handleNavClick("discover", "/discover")}
        >
          <CompassOutlined style={{ marginRight: "8px" }} /> Discover
        </Button>
      </div>
      <Menu
        mode="inline"
        style={{
          background: "#f5f5f5",
          maxHeight: "40vh",
          overflow: "auto",
        }}
        selectedKeys={[activeThread?.id]}
        defaultOpenKeys={isMobile ? [] : ["library"]}
      >
        {isMobile ? (
          <>
            <Menu.Item
              key="library"
              style={{
                fontWeight: "bold",
                cursor: "default",
                backgroundColor: "#ffffff",
                marginTop: "20%",
              }}
            >
              <ReadOutlined style={{ fontSize: "large", color: "grey" }} />
              <span style={{ marginLeft: "10px" }}>Library</span>
            </Menu.Item>
            {threads.map((thread) => (
              <Menu.Item
                key={thread.id}
                onClick={() => {
                  handleThreadClick(thread);
                  if (isMobile) setSiderVisible(false);
                }}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div style={{ flex: 1, overflow: "hidden" }}>
                    <span
                      style={{
                        marginRight: "1px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {thread.name}
                    </span>
                  </div>
                  <div>
                    <Dropdown
                      overlay={
                        <MenuComponent
                          handleMenuClick={handleMenuClick}
                          handleInputChange={handleInputChange}
                          user_value_cookie={user_value_cookie}
                          thread={thread}
                          newChatName={newChatName}
                          setLoading={setLoading}
                          setActiveThread={setActiveThread}
                          threads={threads}
                        />
                      }
                      trigger={["click"]}
                      style={{ zIndex: 5010 }}
                    >
                      <Button
                        type="link"
                        icon={<EllipsisOutlined />}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Dropdown>
                  </div>
                </div>
              </Menu.Item>
            ))}
          </>
        ) : (
          <Menu.SubMenu
            key="library"
            style={{ background: "#ffffff" }}
            title="Library"
            icon={<ReadOutlined style={{ fontSize: "large", color: "grey" }} />}
          >
            {threads.map((thread) => (
              <Menu.Item
                key={thread.id}
                onClick={() => {
                  handleThreadClick(thread);
                  if (isMobile) setSiderVisible(false);
                }}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Tooltip
                    title={thread.name}
                    placement="right"
                    trigger={["hover"]}
                    overlayInnerStyle={{
                      backgroundColor: "#f0f0f0",
                      color: "black",
                    }}
                  >
                    <div style={{ flex: 1, overflow: "hidden" }}>
                      <span
                        style={{
                          marginRight: "1px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {thread.name}
                      </span>
                    </div>
                  </Tooltip>
                  <div>
                    <Dropdown
                      overlay={
                        <MenuComponent
                          handleMenuClick={handleMenuClick}
                          handleInputChange={handleInputChange}
                          user_value_cookie={user_value_cookie}
                          thread={thread}
                          newChatName={newChatName}
                          setLoading={setLoading}
                          setActiveThread={setActiveThread}
                          threads={threads}
                        />
                      }
                      trigger={["click"]}
                      style={{ zIndex: 5010 }}
                    >
                      <Button
                        type="link"
                        icon={<EllipsisOutlined />}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Dropdown>
                  </div>
                </div>
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        )}
      </Menu>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          textAlign: "center",
          paddingBottom: "10px",
        }}
      >
        {isMobile && !currentUser && (
          <div style={{ marginBottom: "8%" }}>
            <Button
              style={{
                backgroundColor: "#559e83",
                color: "white",
                margin: "1%",
                width: "80%",
                marginBottom: "2%",
              }}
              onClick={() => navigateTo("/SignUp")}
            >
              Sign up
            </Button>
            <Button
              style={{ margin: "1%", width: "80%" }}
              onClick={() => navigateTo("/Login")}
            >
              Log in
            </Button>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
          }}
        >
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "grey",
              fontSize: "small",
              margin: "3%",
              cursor: "pointer",
            }}
            onClick={handleBlogClick}
          >
            Blog
          </button>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "grey",
              fontSize: "small",
              margin: "2%",
              cursor: "pointer",
            }}
            onClick={handleMetricsClick}
          >
            Metrics
          </button>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "grey",
              fontSize: "small",
              margin: "3%",
              cursor: "pointer",
            }}
            onClick={handleAboutUsClick}
          >
            AboutUs
          </button>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "grey",
              fontSize: "small",
              margin: "3%",
              cursor: "pointer",
            }}
            onClick={handleContactClick}
          >
            Contact
          </button>
        </div>
      </div>
    </Sider>
  );
};

export default SideBarComponent;

export const HeaderComponent = ({
  isMobile,
  toggleSider,
  navigate,
  handleNewChatClick,
}) => {
  if (!isMobile) return null;

  return (
    <Header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "whitesmoke",
        zIndex: 1000,
        position: "fixed",
        top: 0,
        left: 0, // Ensure header starts from the left edge
        width: "100vw", // Use full width to prevent gaps
        padding: "0 16px", // Add padding instead of reducing width
        boxSizing: "border-box",
      }}
    >
      <Button
        icon={<MenuUnfoldOutlined />}
        onClick={toggleSider}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "grey",
        }}
      />
      <Button
        style={{ backgroundColor: "transparent", border: "none" }}
        onClick={handleNewChatClick}
      >
        Stockbuzz.ai
      </Button>
      <Button
        icon={<PlusCircleOutlined />}
        onClick={handleNewChatClick}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "grey",
        }}
      />
    </Header>
  );
};

export const BottomLine = ({ isMobile }) => {
  const desktopStyle = {
    position: "fixed",
    bottom: 0,
    left: "45%",
    transform: "translateX(-35%)",
    color: "grey",
    backgroundColor: "white",
    padding: "1%",
    paddingTop: "1%",
    zIndex: 99, // Ensure it appears above other elements
    width: "100%", // Optional: Set width to 100% if you want it to span the entire bottom
    textAlign: "center", // Optional: Center text

    fontSize: "small",
  };
  const mobileStyle = {
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    color: "grey",
    backgroundColor: "white",
    padding: "1%",
    paddingTop: "10%",
    zIndex: 99,
    width: "100%",
    textAlign: "center",
    fontSize: "x-small",
  };

  return (
    <div style={isMobile ? mobileStyle : desktopStyle}>
      Not intended as financial advice, please perform your due diligence{" "}
      <ReadOutlined />
    </div>
  );
};
